import { AddCircleRounded } from '@mui/icons-material'
import { Box, IconButton, Stack, Typography, useTheme } from '@mui/material'
import { useState } from 'react'
import { AddProjectMemberModal } from './AddProjectMemberModal'
import { ProjectMembersTable } from './ProjectMembersTable'

export const ProjectMembers = () => {
  const theme = useTheme()

  const [showModel, setShowModel] = useState(false)

  return (
    <Box>
      <AddProjectMemberModal open={showModel} setOpen={setShowModel} />

      <Stack direction="row" alignItems="center" mb={1}>
        <Typography fontSize="1rem" fontWeight={theme.typography.fontWeightBold} color="secondary">
          Members
        </Typography>
        <IconButton size="small" onClick={() => setShowModel(true)}>
          <AddCircleRounded sx={{ color: 'primary.main' }} />
        </IconButton>
      </Stack>

      <ProjectMembersTable />
    </Box>
  )
}
